/* Lead time checkbox — Eurus / Alpine (Bloomex-style): PDP + collection contexts.
 *
 * ATC: button.add_to_cart_button, #x-atc-button-*, .choose_option_atc (see EURUS_ATC_SELECTORS).
 *
 * Contexts:
 *   - [id^="choose-options-template"] — card / section choose-options shells
 *   - #quickview-product-content / .x-quickview-modal — collection quick-view modal (AJAX HTML)
 *
 * Document init skips choose-options + Eurus quick-view subtrees (separate initRoot per shell).
 * Orphan detection + subtree observer on quick-view content when markup appears after open.
 */
(function () {
  if (window.LeadTimeCheckboxEurusInit) {
    return;
  }

  var rootStates = new WeakMap();

  function injectEurusVisibilityCssOnce() {
    if (document.getElementById('lead-time-eurus-visibility-css')) {
      return;
    }
    var s = document.createElement('style');
    s.id = 'lead-time-eurus-visibility-css';
    s.textContent =
      '.lead-time-restriction.lead-time-restriction--visible{display:block!important;}' +
      'button.lead-time-atc-blocked{pointer-events:none!important;cursor:not-allowed!important;}';
    document.head.appendChild(s);
  }

  function applyLeadTimePayload(entry, leadTime) {
    if (entry.aborted) {
      return;
    }
    entry.state.pending = false;
    entry.state.resolved = true;

    if (
      !leadTime ||
      typeof leadTime.leadTimeDays !== 'number' ||
      leadTime.leadTimeDays <= 0
    ) {
      entry.state.agreementRequired = false;
      entry.state.leadTimeDays = 0;
      entry.renderContainer();
      entry.applyState();
      return;
    }

    if (!leadTime.enforceUserAgreement) {
      entry.state.agreementRequired = false;
      entry.state.leadTimeDays = leadTime.leadTimeDays;
      entry.renderContainer();
      entry.applyState();
      return;
    }

    entry.state.agreementRequired = true;
    entry.state.leadTimeDays = leadTime.leadTimeDays;
    entry.state.agreementChecked = entry.checkbox ? entry.checkbox.checked : false;
    entry.renderContainer();
    entry.applyState();
  }

  /** Uses window.__leadTimeEurusEnsureLeadTime from message script (shared cache + single-flight). */
  function fetchLeadTimeViaEnsure(productId) {
    var ensure = window.__leadTimeEurusEnsureLeadTime;
    if (typeof ensure === 'function') {
      return ensure(productId);
    }
    var pid = String(productId);
    window.__leadTimeEurusApiCache = window.__leadTimeEurusApiCache || {};
    window.__leadTimeEurusInflight = window.__leadTimeEurusInflight || {};
    var cache = window.__leadTimeEurusApiCache;
    var inflight = window.__leadTimeEurusInflight;
    if (cache[pid]) {
      return Promise.resolve(cache[pid]);
    }
    if (inflight[pid]) {
      return inflight[pid];
    }
    inflight[pid] = fetch('/apps/api/products-lead-time', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ productIds: [pid] })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Lead time endpoint error: ' + response.status);
        }
        return response.json();
      })
      .then(function (data) {
        var leadTime = data && data.leadTime ? data.leadTime : data;
        cache[pid] = leadTime;
        document.dispatchEvent(
          new CustomEvent('lead-time-eurus:lead-time-ready', {
            bubbles: true,
            detail: { productId: pid, leadTime: leadTime }
          })
        );
        return leadTime;
      })
      .finally(function () {
        delete inflight[pid];
      });
    return inflight[pid];
  }

  function escapeValue(val) {
    if (!val) return '';
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(val);
    }
    return String(val).replace(/"/g, '\\"');
  }

  function queryAll(scope, selector) {
    if (scope && scope.querySelectorAll) {
      return scope.querySelectorAll(selector);
    }
    return document.querySelectorAll(selector);
  }

  function getById(scope, id) {
    if (!id) return null;
    if (scope && scope.querySelector) {
      return scope.querySelector('#' + escapeValue(id));
    }
    return document.getElementById(id);
  }

  var EURUS_ATC_SELECTORS = [
    'button.add_to_cart_button',
    'button[name="add"].add_to_cart_button',
    'button.choose_option_atc',
    'button.choose_option_quickview[name="add"]',
    'button.button--quickview[name="add"]',
    '[id^="x-atc-button"]'
  ];

  function addEurusButtons(target, set) {
    if (!target || !target.querySelectorAll) {
      return;
    }
    EURUS_ATC_SELECTORS.forEach(function (sel) {
      target.querySelectorAll(sel).forEach(function (btn) {
        set.add(btn);
      });
    });
  }

  function isEurusAtcButton(btn) {
    if (!btn || !btn.matches) {
      return false;
    }
    if (btn.matches('button.add_to_cart_button')) {
      return true;
    }
    if (btn.matches('button.choose_option_atc')) {
      return true;
    }
    if (btn.matches('button.choose_option_quickview[name="add"]')) {
      return true;
    }
    if (btn.id && btn.id.indexOf('x-atc-button') === 0) {
      return true;
    }
    if (
      btn.matches('button[type="submit"][name="add"]') &&
      btn.closest('form[action*="/cart/add"]')
    ) {
      return true;
    }
    return false;
  }

  function findLeadTimeEntryFromAtcButton(btn) {
    var form = btn.closest('form');
    if (!form && btn.getAttribute('form')) {
      form = document.getElementById(btn.getAttribute('form'));
    }
    if (!form) {
      return null;
    }
    var container = form.querySelector('[data-lead-time-scope^="lead-time-checkbox-eurus-"]');
    if (!container) {
      var pi = form.closest('[id^="ProductInfo-choose-option"]');
      if (pi) {
        container = pi.querySelector('[data-lead-time-scope^="lead-time-checkbox-eurus-"]');
      }
    }
    return container && container.__leadTimeEurusEntry ? container.__leadTimeEurusEntry : null;
  }

  function findLeadTimeEntryFromProductForm(form) {
    if (!form) {
      return null;
    }
    var container = form.querySelector('[data-lead-time-scope^="lead-time-checkbox-eurus-"]');
    if (!container) {
      var pi = form.closest('[id^="ProductInfo-choose-option"]');
      if (pi) {
        container = pi.querySelector('[data-lead-time-scope^="lead-time-checkbox-eurus-"]');
      }
    }
    return container && container.__leadTimeEurusEntry ? container.__leadTimeEurusEntry : null;
  }

  function collectButtons(scope, root, formId) {
    var set = new Set();
    var buttonSelectors = ['button[type="submit"]', 'input[type="submit"]'];

    if (formId) {
      var targetForm = getById(scope, formId) || document.getElementById(formId);
      if (targetForm) {
        buttonSelectors.forEach(function (selector) {
          targetForm.querySelectorAll(selector).forEach(function (btn) {
            set.add(btn);
          });
        });
        addEurusButtons(targetForm, set);
      }
      var formSelector = buttonSelectors
        .map(function (s) {
          return s + '[form="' + escapeValue(formId) + '"]';
        })
        .join(',');
      queryAll(scope, formSelector).forEach(function (btn) {
        set.add(btn);
      });
      document.querySelectorAll(formSelector).forEach(function (btn) {
        set.add(btn);
      });
      queryAll(scope, 'button[form="' + escapeValue(formId) + '"].add_to_cart_button').forEach(function (btn) {
        set.add(btn);
      });
      document.querySelectorAll('button[form="' + escapeValue(formId) + '"].add_to_cart_button').forEach(function (btn) {
        set.add(btn);
      });
    }

    var rootButtons =
      (root && root.closest
        ? root.closest(
            'section, form, .product-add-to-cart-container, .buy-buttons, ' +
              'product-info, [id^="choose-options-template"], ' +
              '[id^="ProductInfo-choose-option"], ' +
              '[id^="shopify-section-template--"], .productView, .product-info'
          )
        : null) || (root ? root.parentElement : null);

    if (rootButtons) {
      buttonSelectors.forEach(function (selector) {
        rootButtons.querySelectorAll(selector).forEach(function (btn) {
          set.add(btn);
        });
      });
      addEurusButtons(rootButtons, set);
    }

    queryAll(scope, 'buy-buttons [type="submit"]').forEach(function (btn) {
      set.add(btn);
    });
    queryAll(scope, '.product-add-to-cart-container [type="submit"]').forEach(function (btn) {
      set.add(btn);
    });
    queryAll(scope, 'button.add_to_cart_button[name="add"]').forEach(function (btn) {
      set.add(btn);
    });

    var productSection =
      root && root.closest ? root.closest('[id^="shopify-section-"]') : null;
    if (formId && productSection && root && productSection.contains(root)) {
      var sectionForm = document.getElementById(formId);
      if (sectionForm && productSection.contains(sectionForm)) {
        addEurusButtons(sectionForm, set);
      }
    }

    return Array.from(set).filter(function (btn) {
      if (formId) {
        var f = getById(scope, formId) || document.getElementById(formId);
        if (f) {
          if (f.contains(btn)) {
            return true;
          }
          if (btn.getAttribute('form') === formId) {
            return true;
          }
          return false;
        }
      }
      var hostForm = root && root.closest ? root.closest('form') : null;
      if (hostForm) {
        return hostForm.contains(btn) || btn.getAttribute('form') === hostForm.id;
      }
      if (rootButtons && rootButtons.contains(btn) && isEurusAtcButton(btn)) {
        return true;
      }
      return btn.closest('form') || btn.hasAttribute('form');
    });
  }

  function updateButton(btn, disabled, forceEnable) {
    if (!btn || (btn.classList && btn.classList.contains('oot-disabled'))) {
      return;
    }

    if (disabled) {
      if (!btn.hasAttribute('disabled')) {
        btn.setAttribute('disabled', 'disabled');
      }
      btn.setAttribute('data-lead-time-disabled', '1');
      if (!btn.classList.contains('lead-time-disabled')) {
        btn.classList.add('lead-time-disabled');
      }
      btn.setAttribute('data-lead-time-class', '1');
      if (!btn.classList.contains('lead-time-atc-blocked')) {
        btn.classList.add('lead-time-atc-blocked');
      }
    } else {
      if (forceEnable) {
        if (btn.hasAttribute('disabled')) {
          btn.removeAttribute('disabled');
        }
        btn.removeAttribute('data-lead-time-disabled');
        btn.classList.remove('lead-time-disabled');
        btn.removeAttribute('data-lead-time-class');
        btn.classList.remove('lead-time-atc-blocked');
      } else {
        if (btn.getAttribute('data-lead-time-disabled') === '1') {
          btn.removeAttribute('disabled');
          btn.removeAttribute('data-lead-time-disabled');
        }
        if (btn.getAttribute('data-lead-time-class') === '1') {
          btn.classList.remove('lead-time-disabled');
          btn.removeAttribute('data-lead-time-class');
        }
        btn.classList.remove('lead-time-atc-blocked');
      }
    }
  }

  function isVariantChange(target) {
    if (!target || !target.matches) {
      return false;
    }
    if (
      target.matches('input[name="id"], select[name="id"]') ||
      target.matches('input[type="radio"][name], input[type="radio"][form]') ||
      target.matches('input[type="radio"]')
    ) {
      return true;
    }
    if (target.id && target.id.indexOf('update-variant') === 0) {
      return true;
    }
    return !!target.closest('variant-selects, product-form, form[action*="/cart/add"]');
  }

  function createEntry(container, scope) {
    var productId = container.getAttribute('data-product-id');
    if (!productId || !/^\d+$/.test(productId)) {
      return null;
    }

    var entry = {
      aborted: false,
      container: container,
      scope: scope,
      formId: container.getAttribute('data-form-id') || '',
      checkbox: container.querySelector('[data-lead-time-checkbox]'),
      daysNode: container.querySelector('[data-lead-time-days]'),
      buttons: [],
      buttonObservers: new Map(),
      state: {
        pending: true,
        agreementRequired: false,
        agreementChecked: false,
        leadTimeDays: 0,
        resolved: false
      }
    };

    entry.state.agreementChecked = entry.checkbox ? entry.checkbox.checked : false;

    entry.shouldDisable = function () {
      return entry.state.pending || (entry.state.agreementRequired && !entry.state.agreementChecked);
    };

    entry.renderContainer = function () {
      if (!entry.state.resolved || !entry.state.agreementRequired || entry.state.leadTimeDays <= 0) {
        entry.container.style.display = 'none';
        entry.container.classList.remove('lead-time-restriction--visible');
        return;
      }
      if (entry.daysNode) {
        entry.daysNode.textContent = entry.state.leadTimeDays;
      }
      injectEurusVisibilityCssOnce();
      entry.container.classList.add('lead-time-restriction--visible');
      entry.container.style.display = 'block';
    };

    entry.applyState = function () {
      var disabled = entry.shouldDisable();
      entry.buttons.forEach(function (btn) {
        updateButton(btn, disabled, !disabled && entry.state.resolved);
      });
    };

    entry.syncButtonObservers = function () {
      var nextSet = new Set(entry.buttons);
      entry.buttonObservers.forEach(function (obs, btn) {
        if (!nextSet.has(btn)) {
          obs.disconnect();
          entry.buttonObservers.delete(btn);
        }
      });
      entry.buttons.forEach(function (btn) {
        if (!btn || entry.buttonObservers.has(btn)) {
          return;
        }
        var obs = new MutationObserver(function () {
          if (entry.shouldDisable()) {
            updateButton(btn, true, false);
          }
        });
        obs.observe(btn, {
          attributes: true,
          attributeFilter: ['disabled', 'class']
        });
        entry.buttonObservers.set(btn, obs);
      });
    };

    entry.refreshDom = function () {
      var nextFormId = entry.container.getAttribute('data-form-id') || '';
      if (nextFormId && nextFormId !== entry.formId) {
        entry.formId = nextFormId;
      }
      entry.checkbox = entry.container.querySelector('[data-lead-time-checkbox]');
      entry.daysNode = entry.container.querySelector('[data-lead-time-days]');
      if (entry.checkbox) {
        entry.state.agreementChecked = entry.checkbox.checked;
      }
      entry.buttons = collectButtons(entry.scope, entry.container, entry.formId);
      entry.syncButtonObservers();
      entry.renderContainer();
      entry.applyState();
    };

    entry.onCheckboxChange = function (event) {
      var target = event && event.target ? event.target : null;
      if (!target || !target.matches || !target.matches('[data-lead-time-checkbox]')) {
        return;
      }
      if (!entry.container.contains(target)) {
        return;
      }
      entry.state.agreementChecked = target.checked;
      entry.applyState();
    };

    entry.fetchLeadTime = function () {
      fetchLeadTimeViaEnsure(productId)
        .then(function (leadTime) {
          if (entry.aborted) {
            return;
          }
          applyLeadTimePayload(entry, leadTime);
        })
        .catch(function (error) {
          if (entry.aborted) {
            return;
          }
          entry.state.pending = false;
          entry.state.resolved = true;
          entry.state.agreementRequired = false;
          entry.state.leadTimeDays = 0;
          entry.renderContainer();
          entry.applyState();
          console.error('lead-time-checkbox-global-eurus error:', error);
        });
    };

    entry.init = function () {
      entry.container.__leadTimeEurusEntry = entry;
      entry.container.addEventListener('change', entry.onCheckboxChange, true);
      entry.refreshDom();
      entry.fetchLeadTime();
    };

    entry.destroy = function () {
      entry.aborted = true;
      entry.buttonObservers.forEach(function (obs) {
        obs.disconnect();
      });
      entry.buttonObservers.clear();
      if (entry.container) {
        delete entry.container.__leadTimeEurusEntry;
      }
      entry.container.removeEventListener('change', entry.onCheckboxChange, true);
    };

    return entry;
  }

  function initRoot(root, options) {
    if (!root || !root.querySelectorAll) {
      return;
    }

    var existing = rootStates.get(root);
    if (existing) {
      if (options && options.force) {
        existing.destroy();
        rootStates.delete(root);
      } else {
        if (options && options.refresh) {
          existing.refreshAll();
        }
        return;
      }
    }

    var state = {
      root: root,
      entries: new Map()
    };

    state.refreshAll = function () {
      state.entries.forEach(function (entry) {
        entry.refreshDom();
      });
    };

    state.onRootChange = function (event) {
      if (isVariantChange(event.target)) {
        state.refreshAll();
      }
    };

    state.destroy = function () {
      state.root.removeEventListener('change', state.onRootChange, true);
      state.entries.forEach(function (entry) {
        entry.destroy();
      });
      state.entries.clear();
    };

    var skipChoose =
      options && options.skipContainersInsideChooseOptions;
    var skipQuickView = options && options.skipContainersInsideQuickView;
    root.querySelectorAll('[data-lead-time-scope]').forEach(function (container) {
      if (skipChoose && container.closest('[id^="choose-options-template"]')) {
        return;
      }
      if (skipQuickView && container.closest('.x-quickview-modal')) {
        return;
      }
      var entry = createEntry(container, root);
      if (!entry) {
        return;
      }
      state.entries.set(container, entry);
      entry.init();
    });

    root.addEventListener('change', state.onRootChange, true);
    rootStates.set(root, state);
  }

  function getChooseOptionRoots() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[id^="choose-options-template"]')
    );
  }

  /** Card "choose options" flyout: markup often under ProductInfo-choose-option*, not choose-options-template. */
  function getProductInfoChooseOptionRoots() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[id^="ProductInfo-choose-option"]')
    );
  }

  /**
   * Theme may omit liquid snippets on product cards — inject minimal message + checkbox
   * before ATC (same scopes as lead-time-*-global-eurus.liquid).
   */
  function injectEurusChooseOptionCardLeadTimeIfMissing() {
    var created = false;
    document.querySelectorAll('form[id^="product-form-choose-option"]').forEach(function (form) {
      var idInput = form.querySelector('input[name="product-id"]');
      if (!idInput) {
        return;
      }
      var pid = idInput.value;
      if (!pid || !/^\d+$/.test(pid)) {
        return;
      }
      var scopeCb = 'lead-time-checkbox-eurus-' + pid;
      if (form.querySelector('[data-lead-time-scope="' + scopeCb + '"]')) {
        return;
      }
      var wrap = document.createElement('div');
      wrap.className = 'lead-time-restriction';
      wrap.setAttribute('data-lead-time-scope', scopeCb);
      wrap.setAttribute('data-product-id', pid);
      wrap.setAttribute('data-form-id', form.id || '');
      wrap.style.display = 'none';
      wrap.innerHTML =
        '<label class="lead-time-confirmation__label" style="display:flex;gap:6px;align-items:center">' +
        '<input type="checkbox" class="lead-time-confirmation__checkbox" data-lead-time-checkbox> ' +
        '<span>I understand that this product will be shipped in <span data-lead-time-days></span> days.</span>' +
        '</label>';
      form.insertBefore(wrap, form.firstChild);
      created = true;
    });
    return created;
  }

  /** Eurus collection modal: AJAX injects product HTML here (see #quickview-product-content). */
  function getQuickViewContentRoot() {
    return document.getElementById('quickview-product-content');
  }

  function hasOrphanLeadTimeScope(root) {
    if (!root || !root.querySelectorAll) {
      return false;
    }
    var nodes = root.querySelectorAll('[data-lead-time-scope^="lead-time-checkbox-eurus-"]');
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].__leadTimeEurusEntry) {
        return true;
      }
    }
    return false;
  }

  function initEurusQuickContexts() {
    injectEurusChooseOptionCardLeadTimeIfMissing();
    var legacy = document.getElementById('Product-Drawer-Content');
    if (legacy) {
      initRoot(legacy, { force: true });
    }
    getChooseOptionRoots().forEach(function (r) {
      initRoot(r, { force: true });
    });
    getProductInfoChooseOptionRoots().forEach(function (r) {
      initRoot(r, { force: true });
    });
    var qv = getQuickViewContentRoot();
    if (qv) {
      initRoot(qv, { force: true });
    }
  }

  var chooseShellTimer;
  function scheduleChooseShellReinit() {
    clearTimeout(chooseShellTimer);
    chooseShellTimer = setTimeout(function () {
      getChooseOptionRoots().forEach(function (root) {
        initRoot(root, { force: true });
      });
      var qv = getQuickViewContentRoot();
      if (qv && hasOrphanLeadTimeScope(qv)) {
        initRoot(qv, { force: true });
      }
    }, 200);
  }

  var orphanTimer;
  function scheduleEurusOrphanReinit() {
    clearTimeout(orphanTimer);
    orphanTimer = setTimeout(function () {
      injectEurusChooseOptionCardLeadTimeIfMissing();
      var qv = getQuickViewContentRoot();
      if (qv && hasOrphanLeadTimeScope(qv)) {
        initRoot(qv, { force: true });
      }
      getChooseOptionRoots().forEach(function (r) {
        if (hasOrphanLeadTimeScope(r)) {
          initRoot(r, { force: true });
        }
      });
      getProductInfoChooseOptionRoots().forEach(function (r) {
        if (hasOrphanLeadTimeScope(r)) {
          initRoot(r, { force: true });
        }
      });
      if (hasOrphanLeadTimeScope(document.documentElement)) {
        initRoot(document, {
          skipContainersInsideChooseOptions: true,
          skipContainersInsideQuickView: true,
          force: true
        });
      }
    }, 140);
  }

  function attachQuickViewSubtreeObserver() {
    var qv = getQuickViewContentRoot();
    if (!qv || qv.dataset.leadTimeEurusSubtreeMo) {
      return;
    }
    qv.dataset.leadTimeEurusSubtreeMo = '1';
    new MutationObserver(function () {
      scheduleEurusOrphanReinit();
    }).observe(qv, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRoot(document, {
      skipContainersInsideChooseOptions: true,
      skipContainersInsideQuickView: true
    });
    initEurusQuickContexts();
    attachQuickViewSubtreeObserver();
  });

  document.addEventListener('quick-view:open', function () {
    initEurusQuickContexts();
    attachQuickViewSubtreeObserver();
    scheduleEurusOrphanReinit();
  });

  var chooseShellObserver = new MutationObserver(function (mutations) {
    var touched = false;
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type !== 'attributes' || m.attributeName !== 'class') {
        continue;
      }
      var t = m.target;
      if (t && t.id && t.id.indexOf('choose-options-template') === 0) {
        touched = true;
        break;
      }
    }
    if (!touched) {
      return;
    }
    scheduleChooseShellReinit();
  });
  chooseShellObserver.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });

  var docOrphanObserver = new MutationObserver(function () {
    scheduleEurusOrphanReinit();
  });
  docOrphanObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var btn =
        t && t.closest
          ? t.closest(
              'button.add_to_cart_button, button.choose_option_atc, button.choose_option_quickview[name="add"], button.button--quickview[name="add"], [id^="x-atc-button"]'
            )
          : null;
      if (!btn && t && t.closest) {
        var submitAdd = t.closest('button[type="submit"][name="add"]');
        if (submitAdd && submitAdd.closest('form[action*="/cart/add"]')) {
          btn = submitAdd;
        }
      }
      if (!btn || !isEurusAtcButton(btn)) {
        return;
      }
      var entry = findLeadTimeEntryFromAtcButton(btn);
      if (!entry || !entry.shouldDisable()) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.nodeName !== 'FORM') {
        return;
      }
      if (!form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) {
        return;
      }
      var entry = findLeadTimeEntryFromProductForm(form);
      if (!entry || !entry.shouldDisable()) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }
    },
    true
  );

  window.LeadTimeCheckboxEurusInit = {
    initRoot: initRoot,
    initChooseOptions: initEurusQuickContexts,
    initQuickView: function () {
      attachQuickViewSubtreeObserver();
      scheduleEurusOrphanReinit();
    }
  };
})();
